import EnumSelect from 'components/field/EnumSelect';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import AppLogger from 'utils/AppLogger';

import * as S from './FilterInput.styled';

/**
 * @author Burak Unsal
 */
const DynamicListMultiSelect = (props) => {
	const {
		placeholder,
		fetchUrl,
		accessor,
		value,
		setValue,
		multipleSelection,
		fixedContainerWidth = true,
		className,
		filters,
		requestParameters = null,
		...moreProps
	} = props;

	const axiosPrivate = useAxiosPrivate();
	const { showError } = useAlert();

	const fetchFunction = async () =>
		await axiosPrivate
			.post(fetchUrl, {
				columns: [accessor],
				filterKey: accessor,
				filter: filters,
				...requestParameters
			})
			.then((response) => response.data.data.map((item) => item.value))
			.catch((error) => {
				AppLogger.error(error);
				showError();
			});

	return (
		<S.InputContainer className={className}>
			<EnumSelect
				value={value}
				setValue={setValue}
				multipleSelection={multipleSelection}
				fixedContainerWidth={fixedContainerWidth}
				placeholder={placeholder}
				fetchFunction={fetchFunction}
				{...moreProps}
			/>
		</S.InputContainer>
	);
};

export default DynamicListMultiSelect;
